export const acceptedImageTypes = {
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
}
